const PERCENT_FORMAT = new Intl.NumberFormat('en', {
  style: 'percent',
  maximumFractionDigits: 2,
});

export function formatPercent(fraction: number): string {
  return PERCENT_FORMAT.format(fraction);
}
